<template>
    <div id="sub-body" class="sub-body">        
        <div class="nav-bg"></div>
        
        <div class="fixed-box">
            <div class="wrapper">
                <div id="left" class="left">
                    <div id="brand-name" class="brand-name">{{ name }}</div>   
                    <div id="brand-desc" class="brand-desc">{{ desc }}</div>
                    <div id="brand-cate" class="brand-cate">
                        <div class="row" v-if="works_keys.length > 3">
                            <div class="bpsm col-6"
                                v-for="(imgs, key, idx) in this.works" 
                                :key="idx" 
                                :class="{ 'on': activeMenu == idx }"
                                @click="moveTo(key, idx)">{{ key | keyName }}</div>
                        </div>
                        <div class="bpsm" v-else
                            v-for="(imgs, key, idx) in this.works" 
                            :key="idx" 
                            :class="{ 'on': activeMenu == idx }"
                            @click="moveTo(key, idx)">{{ key | keyName }}</div>
                    </div>
                    <div id="white-bg" class="white-bg"></div>
                    <div id="right" class="right">
                        <div class="portfolio" id="fixed-box" :class="{ 'effect': effect }">
                            <div class="content-box" v-for="(arr, idx) in this.worksNonSec" :class="'link-' + arr.cate.toLowerCase()" :key="idx" @mouseup="openDetail(idx)">
                                <span class="v-play" v-if="arr.type == 'video'">
                                    <svg xmlns="http://www.w.org/2000/svg" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/><path d="M0 0h24v24H0z" fill="none"/></svg>    
                                </span>
                                <img :src="arr.thumb" @load="resize"/>
                            </div>
                            <div class="next_project">
                                <div class="d-flex justify-content-between align-items-center w-100">
                                    <router-link :to="'/client/' + prev['link']" class="d-flex align-items-center">
                                        <template v-if="nowIdx !== 0">
                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20" height="20" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                                                <polyline style="fill:none;stroke:#333;stroke-miterlimit:10;" points="13.5,1.5 5.5,9.5 13.5,17.5 "/>
                                            </svg>
                                            <span class="ml-2">{{ prev['name'] }}</span>
                                        </template>
                                    </router-link>
                                    <div></div>
                                    <router-link :to="'/client/' + next['link']" class="d-flex align-items-center">
                                        <template v-if="nowIdx !== brands.length -1">
                                            <span class="mr-2">{{ next['name'] }}</span>
                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20" height="20" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                                                <polyline style="fill:none;stroke:#333;stroke-miterlimit:10;" points="6.5,1.5 14.5,9.5 6.5,17.5 "/>
                                            </svg>
                                        </template>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-view" :class="{'on': detailView}">
            <div class="modal-header">
                <!-- <div class="category">{{ category }}</div> -->
                <div class="close-bt" @click="detailView=false">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 409.806 409.806">
                        <path d="M228.929,205.01L404.596,29.343c6.78-6.548,6.968-17.352,0.42-24.132c-6.548-6.78-17.352-6.968-24.132-0.42 c-0.142,0.137-0.282,0.277-0.42,0.42L204.796,180.878L29.129,5.21c-6.78-6.548-17.584-6.36-24.132,0.42 c-6.388,6.614-6.388,17.099,0,23.713L180.664,205.01L4.997,380.677c-6.663,6.664-6.663,17.468,0,24.132 c6.664,6.662,17.468,6.662,24.132,0l175.667-175.667l175.667,175.667c6.78,6.548,17.584,6.36,24.132-0.42 c6.387-6.614,6.387-17.099,0-23.712L228.929,205.01z"/>
                    </svg>
                </div>
            </div>
            <div class="contents">
                
                <hooper ref="carousel" @slide="slideUpdated">
                    <slide v-for="(work, idx) in worksNonSec" :key="idx">
                        <div class="media_image" v-if="work.type == 'image'">
                            <div class="absoute-middle">
                                <img :src="work.thumb" />
                            </div>
                        </div>
                        <div class="media_player" v-else>
                            <video class="work-video" loop muted controls />
                        </div>
                    </slide>
                </hooper>

                <div class="carousel_navi">
                    <div class="nav_prev" v-if="this.nowPage > 0" @click="prevSlide()"></div>
                    <div class="nav_next" v-if="this.nowPage < worksNonSec.length - 1" @click="nextSlide()"></div>
                </div>
            </div>
            <div class="paging" v-if="worksNonSec[nowPage]">
                <span class="nested">{{worksNonSec[nowPage].cate | keyName}}</span> <br> <span class="nested">{{ nowPage + 1 }} / {{ worksNonSec.length }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import json                 from '../assets/json/work.json'
import { Hooper, Slide }    from 'hooper'


var isScrolling

export default {
    components: {
        Hooper,
        Slide
	},
    data() {
        return {
            name            : '',
            desc            : '',
            images          : json,
            links           : [],
            works           : [],
            works_keys      : [],
            worksNonSec     : [],
            secLocation     : [],
            detailView      : false,
            detail          : [],
            headerHeight    : 0,
            activeMenu      : 9999,
            winW            : 0,
            winH            : 0,
            nowPage         : 0,
            nowIdx          : 0,
            category        : '',
            effect          : false,
            moving          : false,
            supportsTouch   : false,
            projectOffset   : [],
            prev            : {
                link : '',
                name : '',
            },
            next            : {
                link : '',
                name : '',
            },
            brands          : [
                'apa_beauty',
                'bobbi_brown',
                'coty',
                'dior_beauty',
                'donald+eunsun',
                'estée_lauder',
                'evercell',
                'flirt',
                'garth_fisher',
                'kvd_beauty',
                'la_mer',
                'laura_mercier',
                'rodin',
                'saturday_skin',
            ],
            brands_name     : [
                'APA',
                'Bobbi Brown',
                'Coty',
                'Dior Beauty',
                'Donald+Eunsun', 
                'Estée Lauder',
                'Evercell',
                'Flirt',
                'Garth Fisher',
                'KVD Beauty',
                'La Mer',
                'Laura Mercier',
                'Rodin',
                'Saturday Skin',
            ],
        }
    },
    mounted() {
        window.scrollTo(0, 0)
        window.addEventListener('scroll',       this.scroll)
        window.addEventListener('keydown',      this.keydown)
        window.addEventListener('keydown',      this.escClose)
        window.addEventListener("resize",       this.bodyHeight)

        var supportsOrientationChange = "onorientationchange" in window
        var orientationEvent = supportsOrientationChange ? "orientationchange" : "resize";

        window.addEventListener(orientationEvent, this.videoFull)
        
        this.getData()
        this.bodyHeight()

        this.supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints
        if(!this.supportsTouch) this.effect = true

        setTimeout(() => {
            this.nowPage = 0
        }, 1500)
    },
    beforeDestroy() {
        var supportsOrientationChange = "onorientationchange" in window
        var orientationEvent = supportsOrientationChange ? "orientationchange" : "resize";

        window.removeEventListener('scroll',    this.scroll)
        window.removeEventListener('keydown',   this.keydown)
        window.removeEventListener('keydown',   this.escClose)
        window.removeEventListener("resize",    this.bodyHeight)
        window.removeEventListener(orientationEvent,    this.videoFull)
    },
    methods: {
        getData() {
            const content   = document.querySelector('#fixed-box')
            const account   = this.$route.params.name
            const works     = this.images[account]['works']
            this.works      = works
            this.name       = this.images[account]['name']
            this.desc       = this.images[account]['desc']

            this.worksNonSec    = []
            this.works_keys     = []

            for( var obj in works ) {
                this.works_keys.push(obj)
                for( var link in works[obj]) {
                    this.worksNonSec.push({
                        'cate'  : obj,
                        'type'  : works[obj][link].type,
                        'thumb' : works[obj][link].thumb,
                        'src'   : works[obj][link].src,
                    })
                }
            }

            let prevIdx = 0
            let nextIdx = 0
            this.nowIdx = this.brands.indexOf(account)

            if( this.nowIdx == 0 ) {
                prevIdx = this.brands.length - 1
                nextIdx = this.nowIdx + 1
            }else if( this.nowIdx == this.brands.length - 1 ) {
                prevIdx = this.nowIdx - 1 
                nextIdx = 0
            }else {
                prevIdx = this.nowIdx - 1 
                nextIdx = this.nowIdx + 1
            }


            this.prev['link'] = this.brands[prevIdx]
            this.prev['name'] = this.brands_name[prevIdx]

            this.next['link'] = this.brands[nextIdx]
            this.next['name'] = this.brands_name[nextIdx]
            
        },
        bodyHeight() {
            if(window.outerWidth != this.winW){
                this.winW = window.outerWidth

                setTimeout(() => {
                    this.resize()
                }, 100)
            }
        },
        resize() {
            const subBody   = document.getElementById('sub-body')
            const leftBox   = document.getElementById('left')
            const rightBox  = document.getElementById('right')
            const fixedBox  = document.getElementById('fixed-box')
            const nameBox   = document.getElementById('brand-name')
            const descBox   = document.getElementById('brand-desc')
            const actCate   = document.querySelector('.bpsm.on')

            nameBox.removeAttribute('style')
            descBox.removeAttribute('style')
            fixedBox.removeAttribute('style')
            if(actCate) actCate.classList.remove('on')

            if(document.body.clientWidth >= 768) {
                subBody.style.height        = ( fixedBox.offsetHeight + 180 ) + 'px'
            }else{
                subBody.removeAttribute('style')
            }

            this.secLocation = []
            for(var cate in this.works) {
                var sec = document.querySelectorAll('.link-' + cate)
                if(sec[0]) this.secLocation.push(sec[0].offsetTop)
            }

            this.headerHeight = leftBox.offsetHeight
        },
        moveTo(cate, idx) {
            const elem      = document.querySelectorAll('.link-' + cate.toLowerCase())
            const rightBox  = document.getElementById('right')
            const winW = document.body.clientWidth;
            this.activeMenu = idx

            console.log(cate, idx)

            var smoothScrollFeature = 'scrollBehavior' in document.documentElement.style
            if(smoothScrollFeature) {
                
                var topTo = elem[0].offsetTop - Number(rightBox.style.marginTop.replace('px', ''))
                if(winW < 768) topTo = elem[0].offsetTop - 130 - document.getElementById('brand-cate').offsetHeight

                window.scrollTo({
                    left    : 0, 
                    top     : topTo,
                    behavior: 'smooth'
                })
            }else{
                if(this.moving) return
                this.moving = true
                this.effect = false

                var topTo = elem[0].offsetTop - Number(rightBox.style.marginTop.replace('px', ''))
                if(winW < 768) topTo = elem[0].offsetTop - 130 - document.getElementById('brand-cate').offsetHeight

                var to = topTo
                var i = 0
                var startScroll = window.scrollY
                var scrollHeight = to - startScroll
  
                var int = setInterval(() => {
                    i++
                    var y = startScroll + this.easing(i*.01) * scrollHeight 
                    window.scroll(0, y)
                    if (i == 100) {
                        clearInterval(int);
                        if(!this.supportsTouch) this.effect = true
                        this.moving = false
                    }
                }, 10);
            }
        },
        scroll() {
            const actCate   = document.querySelector('.bpsm.on')
            const target    = document.getElementById('fixed-box')
            const leftBox   = document.getElementById('left')
            const descBox   = document.getElementById('brand-desc')
            const nameBox   = document.getElementById('brand-name')
            const rightBox  = document.getElementById('right')

            if(document.body.clientWidth >= 768) {
                if(!target) return
                target.style.transform = `translate3d(0px, ${-Math.floor(window.scrollY)}px, 0)`
            }else{
                if(window.scrollY <= this.headerHeight - 169) {
                    var per = (window.scrollY ) / 100
                    descBox.style.opacity   = 1 - per
                }else{
                    descBox.style.opacity   = 0
                }
            }

            if(actCate) {
                var active      = 0
                var sy          = window.scrollY + (window.outerHeight/2)

                for(var i=0; i<this.secLocation.length; i++) {
                    if(window.scrollY + Number(rightBox.style.marginTop.replace('px','')) >= this.secLocation[i]) {
                        active = i
                    }
                }

                if(window.scrollY >= document.documentElement.scrollHeight - window.outerHeight) {
                    active = this.secLocation.length - 1
                }
            }
        },
        openDetail(idx) {
            this.nowPage    = idx
            this.detail     = this.worksNonSec[idx]
            this.detailView = true
            this.$refs['carousel'].slideTo(idx)
        },
        closeDetail() {
            this.detailView = false
        },
        escClose(e) {
            if (e.keyCode == 27) {
                this.closeDetail()
            }
        },
        prevSlide() {
            if(this.nowPage < 1) return
            this.detail = this.worksNonSec[this.nowPage]
            this.nowPage--

            this.$refs['carousel'].slidePrev()
        },
        nextSlide() {
            if(this.nowPage >= this.worksNonSec.length - 1) return
            this.detail = this.worksNonSec[this.nowPage]
            this.nowPage++
            this.$refs['carousel'].slideNext()
        },
        keydown() {
            if(!this.detailView) return
            if(event.keyCode == '39') this.nextSlide()
            else if(event.keyCode == '37') this.prevSlide()
        },
        easing(progress) {
            return progress < 0.5 ? 4 * progress * progress * progress : (progress - 1) * (2 * progress - 2) * (2 * progress - 2) + 1
        },
        slideUpdated() {
            this.nowPage = this.$refs['carousel'].currentSlide
            this.afterSlide()
        },
        afterSlide() {
            var v = this.$refs['carousel'].currentSlide
            const activeSlider = document.querySelectorAll('.hooper-slide')
            activeSlider.forEach((arr, idx) => {
                if(arr.querySelector('video')) {
                    if(idx == v) {
                        setTimeout(() => {
                            arr.querySelector('video').style.opacity = 1
                        }, 500);

                        arr.querySelector('video').src = this.worksNonSec[v].src
                        arr.querySelector('video').load()
                    }else{
                        arr.querySelector('video').src = ''
                    }
                }
            })
        },
        videoFull() {
            if(!this.detailView) return

            var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement
            if(fullscreenElement) return

            if(window.orientation == 90 || window.orientation == -90 || window.orientation == 270) {
                var elem = document.querySelector(".hooper-slide.is-active video")
                
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.mozRequestFullScreen) { /* Firefox */
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE/Edge */
                    elem.msRequestFullscreen();
                }
                document.querySelector(".hooper-slide.is-active video").play()
            }

        }
    },
    filters: {
        keyName(v) {
            var txt = v.replace(/_/g, ' ')
            txt = txt.replace('Packaging Product', 'Packaging / Product')
            txt = txt.replace('UIUX', 'UI/UX')
            return txt
        },
    },
    watch: {
        detailView(v) {
            if(v) {
                document.body.className = 'popup-view'
                this.afterSlide()
            }else{
                document.body.className = ''
            }
        },
        $route() {
            document.getElementById('fixed-box').transform = `translate3d(0px, 0, 0)`
            window.scrollTo(0, 0)
            this.getData()
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../assets/scss/pages/detail.scss';
</style>


// WEBPACK FOOTER //
// src/pages/detail.vue